/*
 * Authors: mariushirjanu
 * Created: 06/09/2022
 */
// upgraded from ng1 browselists-default-addedit.component.ts
import * as _ from 'underscore';
import { util } from '../../util';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { GaValidateService } from '../../formly/ga-validate.service';
import { IExtraFieldConfigurationObject } from '../../formly/ga-formly.service';
import { IObject } from '../../../../type_definitions/datatypes';
import { UntypedFormGroup } from '@angular/forms';
import { IDialogButton } from '../ga-message.service';
import { TranslationService } from '../../translation/translation.service';
import { ITranslateText } from '../../wizard/wizard-wrapper.component';

export const BUTTON_SAVE:string = 'save';
export const BUTTON_CANCEL:string = 'cancel';
export const BUTTON_DELETE:string = 'delete';

export interface ILabelOptions {
  [key:string]:string | ITranslateText;
}

@Component({
  selector: 'default-form-dialog',
  template: '' // define templateUrl: DEFAULT_FORM_DIALOG_URL in all children components that extends DefaultFormDialogComponent (eg. webshop-role-add.component.ts)
})
export class DefaultFormDialogComponent implements OnInit, OnChanges {
  @Input() protected model:any;
  @Input() protected adding:boolean;
  @Input() protected saving:boolean;
  @Input() public dialogClass?:string;
  @Input() public closeButton?:boolean; // default true
  @Input() public title:string;
  @Input() public entity:string;
  @Input() protected queryFilters:any;

  @Output() protected onSave:EventEmitter<any> = new EventEmitter();
  @Output() public onCancel:EventEmitter<void> = new EventEmitter();

  public fields:IExtraFieldConfigurationObject[] = [];
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public buttons:IDialogButton[];
  public error?:string; // display an error message
  public loading?:boolean;

  constructor(
    protected validateService:GaValidateService,
    protected translationService?:TranslationService
  ) {
    /***/
  }

  public ngOnInit():void {
    if(this.entity && !this.title){
      // autogenerate title based on the entity name
      this.title = this.translationService.instant(this.adding? 'GA.BUTTONS.ADD_LABEL' : 'GA.BUTTONS.EDIT_LABEL', { label: this.entity });
    }

    this.buttons = [ {
      id: BUTTON_SAVE,
      label: this.translationService.instant(this.adding? 'GA.BUTTONS.ADD_LABEL': 'GA.BUTTONS.SAVE_LABEL', { label: this.entity || '' }),
      className: 'btn btn-success',
      onClick: this.save,
      busy: this.saving
    }, {
      id: BUTTON_CANCEL,
      label: 'GA.BUTTONS.CANCEL',
      className: 'btn btn-danger',
      onClick: () => this.onCancel.emit()
    } ];

    if (!this.model) {
      // initiate empty object when model is undefined
      // formly not allowed undefined as initial model
      this.model = {};
    }

    if(util.isNullOrUndefined(this.closeButton)){
      this.closeButton = true;
    }
  }

  public ngOnChanges(changes:SimpleChanges): void {
    if (changes.saving) {
      // allow controlling button status from the parent
      this.saveButtonBusy = changes.saving.currentValue;
    }
  }

  public getModel():IObject {
    return this.model;
  }

  public save = ():void => {
    this.validateFields()
      .then(() => {
        this.onSave.emit(this.getModel());
      })
      .catch((e) => {
        console.debug('Save browselist exception', e);
      });
  };

  public validateFields(showError:boolean = true):Promise<void|string[]> {
    return this.validateService.validateFields(this.fields, this.model, showError);
  }

  protected set saveButtonBusy(busy:boolean) {
    const button:IDialogButton = _.find(this.buttons, { id: BUTTON_SAVE });
    if (button) {
      button.busy = busy;
    }
  }

  protected set saveButtonDisabled(disabled:boolean) {
    const button:IDialogButton = _.find(this.buttons, { id: BUTTON_SAVE });
    if (button) {
      button.disabled = disabled;
    }
  }

  protected replaceButtonLabels(labelOptions:ILabelOptions):void {
    _.each(labelOptions, (value:string | ITranslateText, id:string) => {
      _.findWhere(this.buttons, { id }).label = _.isString(value) ? this.translationService.instant(value) : this.translationService.instant(value.translateText, value.translateValues);
    });
  }
}